import './AcademicHome.css'
import { IconFolder, IconMicroscope, IconSchool, IconSitemap, IconStars, IconUser } from '@tabler/icons-react'
import React from 'react'
import ViewCard from '../../../components/ViewCard/ViewCard'
import AcademicDbView from '../AcademicDashboard/AcademicDbView/AcademicDbView'

// add here
const ACADEMIC_ITEMS = [
   {
      title: 'Unidades Académicas',
      text: 'Crear capacitaciones, diplomados, cursos, clases.',
      href: 'unidades-academicas',
      icon: < IconSchool size={50} className='ViewCard--icon' color='var(--color-white)' />,
   },
   {
      title: 'Usuarios',
      text: 'Ver, crear o editar usuarios .',
      href: 'usuarios',
      icon: < IconUser size={50} className='ViewCard--icon' color='var(--color-white)' />,
   },
   {
      title: 'Especialidades',
      text: 'Generar nuevas especialidades o editarlas',
      href: 'especialidades',
      icon: < IconMicroscope size={50} className='ViewCard--icon' color='var(--color-white)' />,
   },
   {
      title: 'Valoraciones',
      text: 'Revisar las valoraciones de las clases',
      href: 'valoraciones',
      icon: < IconStars size={50} className='ViewCard--icon' color='var(--color-white)' />,
   },
   {
      title: 'Planes de suscripción',
      text: 'Creación y edición de las características y precios',
      href: 'planes-de-suscripcion',
      icon: < IconSitemap size={50} className='ViewCard--icon' color='var(--color-white)' />,
   },
   {
      title: 'Biblioteca',
      text: 'Crear o editar el contenido de las suscripciones',
      href: 'biblioteca-de-contenido',
      icon: < IconFolder size={50} className='ViewCard--icon' color='var(--color-white)' />,
   },
]

export default function AcademicHome() {
   return (
      <>
    <div className='AcademicHome-grid-container'>
         {ACADEMIC_ITEMS.map(item => (
            < ViewCard item={item} />
        ))}
     </div>
     <div>
      <AcademicDbView/>
     </div>
     </>
   )
}